<template>
	<card>
		<template slot="header">
			<h5 v-if="$slots.title || title" class="card-title">
				<slot name="title">
					{{title}}
				</slot>
			</h5>
		</template>
		<div>
			<!-- <div class="loading-spinner" v-if="isLoading">
				<vue-loaders-ball-spin-fade-loader color="white" scale="1.2"/>
			</div> -->
			<div class="status-table">
				<v-client-table
                    :columns="fields"
                    :data="data"
                    :options="options"
                    @row-clicked = "handleRowClick"
                    class="text-center"
                >
                    
                    <template v-slot:status="props" class="status-bar">
                        <div id="normal-bar" v-if="props.row.status == 'normal'" @click="handleRowClick(props.row)" style="cursor: pointer;"></div>
                        <div id="danger-bar" v-else @click="handleRowClick(props.row)" style="cursor: pointer;"></div>
                    </template>
                </v-client-table>
			</div>
		</div>
	</card>
</template>
<script>
import Card from "./Card.vue";
import { mapActions, mapGetters } from "vuex";
import QuerySetting from '@/mixins/querySetting';
import OctoberData from '@/mixins/octoberData';

export default {
	name: "status-card",
	mixins: [QuerySetting, OctoberData],
	components: {
		Card
	},
	props: {
		title: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			isLoading: true,
            fields: ["id", "sitename", "mac_address","last_date", "status"],
			data: [],
            options: {
				headings: {
					id: "id",
					sitename: "site name",
                    mac_address: "mac address",
					last_date: "last report date"
				},
				sortable: ["id", "sitename", "mac_address", "last_date"],
				texts: {
					filterPlaceholder: "Search...",
				},
				perPage: 10,
				editableColumns: ["sitename"],
			},
		};
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			currentDayPower			: 'influx/getCurrentDayPower',
			currentNightPower		: 'influx/getCurrentNightPower',
			user: 'auth/getUser',
			defaultSiteId: 'auth/getDefaultSiteId',
			defaultSiteName: 'auth/defaultSiteName'
		})
	},
    async created() {
		const siteStatusData = await this.getSiteStatus();
		console.log("site data", siteStatusData);
        this.data = siteStatusData;
	},
	methods: {
		...mapActions({
			getSiteStatus: "admin/getSiteStatus",
		}),

        handleRowClick(row) {
            this.$router.push({ name: "channel_status", params: {id: row.id, name: row.sitename}});
        }
	},
};
</script>
<style lang="scss" scoped>
#normal-bar {
    width: 100%;
    height: 25px;
    background-color: green;
    padding: 0 15px;
}

#danger-bar {
    width: 100%;
    height: 25px;
    background-color: red;
    padding: 0 15px;
}
.total-value {
	position: absolute;
	top: 40%;
	left: 110px;
	text-align: center;

	span {
		font-size: 22px;
		font-family: 'Nunito Sans Regular';
		font-weight: 600;
		line-height: 1.1;
	}
}
</style>
